import { render, staticRenderFns } from "./MatchedTransDetail.vue?vue&type=template&id=c77601ba&"
import script from "./MatchedTransDetail.vue?vue&type=script&lang=js&"
export * from "./MatchedTransDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchedTransDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports